import React from "react";
import MobileRecording from "../recording/mobileRecording";
import Input from "../../common/input";
import SelectByList from "../../common/selectByList";
import DatePicker from "../../common.old/datePicker";
import TimeKeeper from "../../common.old/timeKeeper";
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
// import Joi from "joi-browser";
import Joi from "@hapi/joi";

class AMobileDataForm extends MobileRecording {
    state = {
        data: {},
        errors: {},
        dataTableList: []
    };

    tableName = "";
    tableDefinition = {};

    schema = {};

    componentDidMount = () => {
        this.loadData();
    };

    validate = () => {
        const options = {abortEarly: false};
        const {error} = Joi.object(this.schema).validate(this.state.data, options);
        if (!error) return null;
        // console.log("Form.handleSubmit()", "error =", error);

        const errors = {};
        for (let item of error.details) {
            errors[item.path[0]] = item.message;
        }
        return errors;
    };

    validateProperty = ({name, value}) => {
        const obj = {[name]: value};
        const schema = {[name]: this.schema[name]};

        const {error} = Joi.object(schema).validate(obj);
        return error ? error.details[0].message : null;
    };

    handleSubmit = e => {
        e.preventDefault();

        const errors = this.validate();
        this.setState({errors: errors || {}});
        if (errors) return;

        this.doSubmit();
    };

    //   handleChange = e => {
    handleChange = ({currentTarget: input}) => {
        const errors = {...this.state.errors};
        const errorMessage = this.validateProperty(input);

        if (errorMessage) errors[input.name] = errorMessage;
        else delete errors[input.name];

        const data = {...this.state.data};
        // data[e.currentTarget.name] = e.currentTarget.value;
        data[input.name] = input.value;

        this.setState({data, errors});
    };

    simpleHandleChange = ({name, value}) => {
        const data = {...this.state.data};
        data[name] = value;

        this.setState({data});
    };

    renderButton(configuration) {
        return (
            <button
                disabled={configuration.disabled ? configuration.disabled : null}
                className="btn btn-primary"
            >
                {configuration.label}
            </button>
        );
    }

    renderCancelButton(configuration) {
        return (
            <button onClick={() => this.handleCancel()} className="btn btn-info">
                {configuration.label}
            </button>
        );
    }

    renderSaveButton(configuration) {
        return (
            <button
                onClick={() => this.handleSave(this.state.data)}
                disabled={this.validate()}
                className="btn btn-primary"
            >
                {configuration.label}
            </button>
        );
    }

    renderDeleteButton(configuration) {
        return (
            <button
                onClick={() => this.handleDelete(this.state.data)}
                className="btn btn-danger"
                disabled={this.validate()}
            >
                {configuration.label}
            </button>
        );
    }

    renderDatePicker(configuration) {
        // diese Funktion wird schon beim Rendern ohne Daten aufgerufen
        // da jedoch useState nur 1 mal aufgerufen wird, darf TimeKeeper ohne Daten nicht gerendert werden

        const {data} = this.state;

        return (
            data &&
            configuration.name &&
            data[configuration.name] && (
                <DatePicker
                    name={configuration.name}
                    label={configuration.label ? configuration.label : ""}
                    value={data[configuration.name]}
                    // error={errors[configuration.name]}
                    onSimpleChange={this.simpleHandleChange}
                    help={configuration.help ? configuration.help : null}
                    // autoFocus={configuration.autofocus ? configuration.autofocus : null}
                    disabled={configuration.disabled ? configuration.disabled : null}
                />
            )
        );
    }

    renderTimeKeeper(configuration) {
        // diese Funktion wird schon beim Rendern ohne Daten aufgerufen
        // da jedoch useState nur 1 mal aufgerufen wird, darf TimeKeeper ohne Daten nicht gerendert werden

        const {data} = this.state;

        return (
            data &&
            configuration.name &&
            data[configuration.name] && (
                <TimeKeeper
                    name={configuration.name}
                    label={configuration.label ? configuration.label : ""}
                    value={data[configuration.name]}
                    // error={errors[configuration.name]}
                    onSimpleChange={this.simpleHandleChange}
                    help={configuration.help ? configuration.help : null}
                    // autoFocus={configuration.autofocus ? configuration.autofocus : null}
                    // disabled={configuration.disabled ? configuration.disabled : null}
                />
            )
        );
    }

    renderInput(configuration) {
        const {data, errors} = this.state;
        return (
            <Input
                type={configuration.type ? configuration.type : "text"}
                name={configuration.name}
                label={configuration.label ? configuration.label : ""}
                value={data[configuration.name]}
                error={errors[configuration.name]}
                onChange={this.handleChange}
                help={configuration.help ? configuration.help : null}
                autoFocus={configuration.autofocus ? configuration.autofocus : null}
                disabled={configuration.disabled ? configuration.disabled : null}
            />
        );
    }

    renderSelect(configuration) {
        const {data, errors} = this.state;
        return (
            <SelectByList
                name={configuration.name}
                label={configuration.label ? configuration.label : ""}
                value={data[configuration.name]}
                options={configuration.options}
                error={errors[configuration.name]}
                onChange={this.handleChange}
                help={configuration.help ? configuration.help : null}
                autoFocus={configuration.autofocus ? true : null}
            />
        );
    }

    render = () => {
        const {dataTableList} = this.state;
        const {listFormInstance} = this.props;

        if (dataTableList.length === 0) {
            return <React.Fragment></React.Fragment>;
        }

        const ReactTableFixedColumns = withFixedColumns(ReactTable);

        let columns = [
            {
                Header: <h3>{this.tableName}</h3>,
                columns: []
            }
        ];
        let buttonColumn = {
            Header: (
                <React.Fragment>
                    <div className="btn-toolbar" role="toolbar">
                        {listFormInstance.state.mode === listFormInstance.SHOW_MODE &&
                        listFormInstance.renderBackToListButton()}
                        {listFormInstance.availableModes.add === true &&
                        listFormInstance.state.mode === listFormInstance.SHOW_MODE &&
                        listFormInstance.renderAddButton()}
                        {listFormInstance.availableModes.edit === true &&
                        listFormInstance.state.mode === listFormInstance.SHOW_MODE &&
                        listFormInstance.renderEditButton()}
                        {listFormInstance.availableModes.delete === true &&
                        listFormInstance.state.mode === listFormInstance.SHOW_MODE &&
                        listFormInstance.renderDeleteButton(this.props.id)}

                        {listFormInstance.availableModes.add === true &&
                        listFormInstance.state.mode === listFormInstance.ADD_MODE &&
                        listFormInstance.renderCancelAddOrEditButton()}
                        {listFormInstance.availableModes.add === true &&
                        listFormInstance.state.mode === listFormInstance.ADD_MODE &&
                        listFormInstance.renderSaveButton(this.state.data)}

                        {listFormInstance.availableModes.edit === true &&
                        listFormInstance.state.mode === listFormInstance.EDIT_MODE &&
                        listFormInstance.renderCancelAddOrEditButton()}
                        {listFormInstance.availableModes.edit === true &&
                        listFormInstance.state.mode === listFormInstance.EDIT_MODE &&
                        listFormInstance.renderUpdateButton(
                            this.props.id,
                            this.state.data
                        )}
                    </div>
                </React.Fragment>
            ),
            accessor: "value",
            Cell: cellInfo => this.renderInput(cellInfo.row._original)
        };

        columns[0].columns.push(buttonColumn);

        // im Show-Mode ist alles auf disabled
        const myDataTableList = [];
        for (const item of dataTableList) {
            myDataTableList.push({...item});
        }
        if (listFormInstance.state.mode === listFormInstance.SHOW_MODE) {
            for (const item of myDataTableList) {
                item["disabled"] = true;
            }
        }

        return (
            <React.Fragment>
                <ReactTableFixedColumns
                    columns={columns}
                    data={myDataTableList}
                    defaultPageSize={myDataTableList.length}
                    showPagination={false}
                    // style={{ height: window.innerHeight }}
                />
            </React.Fragment>
        );
    }
}

export default AMobileDataForm;
